import React, { useCallback } from "react";
import { serialize } from "object-to-formdata";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";

import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import { FormikTextareaField } from "components/InputsField/formikInputs/FormikTextareaField";
import Button from "components/common/Button";
import { validation } from "./validate";

import styles from "./styles.module.scss";
import { FORUM } from "endpointsConst";

const initialValues = {
    theme: "",
    message: "",
};

export default function TopicAddForm({ id, onClose }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = useCallback(
        (values) => {
            const formData = serialize({
                ...values,
                forum_category_id: id,
                notify: false,
            });

            axios
                .post(FORUM + "/tickets", formData)
                .then((res) => {
                    navigate(`/forums/topic/${id}/ticket/${res.data.ticket_id}`);
                })
                .catch((e) => {
                    console.log(e.response);
                });
        },
        [navigate, id],
    );

    return (
        <div className={styles.form}>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validation(t)}
            >
                <Form>
                    <FormikTextField
                        name="theme"
                        label={t("forums.topics.topic_section.topic")}
                        placeholder=""
                        wrapperClassName={styles.field}
                        required
                    />
                    <FormikTextareaField
                        name="message"
                        label={t("forums.topics.topic_section.message")}
                        placeholder=""
                        rows="5"
                        required
                    />
                    <div className={styles.buttons}>
                        <button className={styles.cancel} type="button" onClick={onClose}>
                            {t("forums.topics.topic_section.cancel_button")}
                        </button>
                        <Button type="submit">
                            {t("forums.topics.topic_section.create_button")}
                        </Button>
                    </div>
                </Form>
            </Formik>
        </div>
    );
}
